import React, { useState } from 'react';
import { 
    makeStyles, TextField, Card, CardHeader, CardContent, 
    Grid, IconButton, Button, Divider, InputLabel, 
    Typography, Select, MenuItem,
} from '@material-ui/core';
import { Formik, FieldArray, Form, getIn } from 'formik';
import * as Yup from 'yup';
import DeleteIcon from '@material-ui/icons/Delete';

import { db, storage } from './Firebase/firebase';
import './business.css';


const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    title: {
      flexGrow: 1,
    },
    statusText: {
        textAlign: 'center',
    },
    divider: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    }
}));


const Inventories = ({ userInfo, email }) => {

    const classes = useStyles();
    const { inventories } = userInfo;
    const [status, setStatus] = useState('');

    const emptyItem = {
        name: '',
        productType: null,
        pricePerUnit: '',
        unit: '',
        description: '',
        quantity: null,
        fileUrl: null,
        ingredients: null,
    }

    const updateInventories = (inventories) => {
        db.collection('business').doc(email).update({
            inventories,
        }).then(() => {
            console.log("successful");
            setStatus('Your inventories has been updated')
        }).catch((e) => {
            setStatus(e.msg);
        })
    }

    const items = inventories.length > 0 ? inventories : [emptyItem];
    const imgUrls = items.map((item) => item.fileUrl);

    return(
        <>
            <Formik
                initialValues={{
                    items: items,
                    imgUrls: imgUrls,
                }}
                validationSchema={Yup.object({
                    items: Yup.array().of(Yup.object().shape({
                        name: Yup.string().required(),
                        productType: Yup.string().required(),
                        pricePerUnit: Yup.number().required(),
                        unit: Yup.string().required(),
                        quantity: Yup.number().required(),
                        description: Yup.string(),
                        fileUrl: Yup.string().nullable(),
                        ingredients: Yup.string().nullable(),
                    })),
                })}
                onSubmit={(values) => {
                    console.log(values);
                    updateInventories(values.items);
                }}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleSubmit,
                    handleChange,
                    isSubmitting,
                    setFieldValue,
                }) => (
                    <Form id="material-form">
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <FieldArray
                                    name="items"
                                    render={arrayHelpers => {
                                    return (
                                        <div>
                                        {values.items && values.items.length > 0
                                            ? values.items.map((item, index) => {
                                                const name = `items[${index}].name`;
                                                const touchedName = getIn(touched, name);
                                                const errorName = getIn(errors, name);
                            
                                                const pricePerUnit = `items[${index}].pricePerUnit`;
                                                const touchedPricePerUnit = getIn(touched, pricePerUnit);
                                                const errorPricePerUnit = getIn(errors, pricePerUnit);

                                                const unit = `items[${index}].unit`;
                                                const touchedUnit = getIn(touched, unit);
                                                const errorUnit = getIn(errors, unit);

                                                const quantity = `items[${index}].quantity`;
                                                const touchedQuantity = getIn(touched, quantity);
                                                const errorQuantity = getIn(errors, quantity);

                                                const description = `items[${index}].description`;
                                                const touchedDescription = getIn(touched, description);
                                                const errorDescription = getIn(errors, description);

                                                const productType = `items[${index}].productType`;
                                                const touchedProductType = getIn(touched, productType);
                                                const errorProductType = getIn(errors, productType);

                                                const fileUrl = `items[${index}].fileUrl`;
                                                const touchedFileUrl = getIn(touched, fileUrl);
                                                const errorFileUrl = getIn(errors, fileUrl);

                                                const ingredients = `items[${index}].ingredients`;
                                                const touchedIngredients = getIn(touched, ingredients);
                                                const errorIngredients = getIn(errors, ingredients);

                                                return(
                                                <div key={index}>
                                                    <Card>
                                                        <CardHeader
                                                            title={`Item ${index + 1}`}
                                                        />
                                                        <CardContent>
                                                            <Grid container spacing={2}>
                                                            <Grid item xs={12}>
                                                                <TextField
                                                                    label="Item Name"
                                                                    type="text"
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    name={name}
                                                                    value={item.name}
                                                                    helperText={
                                                                        touchedName && errorName
                                                                        ? errorName
                                                                        : ""
                                                                    }
                                                                    onChange={handleChange}
                                                                    error={Boolean(touchedName && errorName)}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                <InputLabel>Product type</InputLabel>
                                                                <Select
                                                                    fullWidth
                                                                    name={productType}
                                                                    variant="outlined"
                                                                    value={values.productType}
                                                                    helperText={
                                                                        touchedProductType && errorProductType
                                                                        ? errorProductType
                                                                        : ""
                                                                    }
                                                                    onChange={handleChange}
                                                                    error={Boolean(touchedProductType && errorProductType)}
                                                                >
                                                                    <MenuItem value={"cake"}>Cake</MenuItem>
                                                                    <MenuItem value={"pastry"}>Pastry</MenuItem>
                                                                    <MenuItem value={"beverage"}>Beverage</MenuItem>
                                                                    <MenuItem value={"coldFood"}>Cold Food</MenuItem>
                                                                    <MenuItem value={"hotFood"}>Hot Food</MenuItem>
                                                                    <MenuItem value={"frozen"}>Frozen</MenuItem>
                                                                    <MenuItem value={"snack"}>Snack</MenuItem>
                                                                    <MenuItem value={"grazingBox"}>Grazing Box</MenuItem>
                                                                    <MenuItem value={"gifts"}>Gifts</MenuItem>
                                                                    <MenuItem value={"homemade"}>Homemade</MenuItem>
                                                                    <MenuItem value={"others"}>Others</MenuItem>
                                                                </Select>
                                                            </Grid>
                                                            <Grid item xs={12} lg={6}>
                                                                <TextField
                                                                    label="Item Price Per Unit ($)"
                                                                    type="number"
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    name={pricePerUnit}
                                                                    value={item.pricePerUnit}
                                                                    helperText={
                                                                        touchedPricePerUnit && errorPricePerUnit
                                                                        ? errorPricePerUnit
                                                                        : ""
                                                                    }
                                                                    onChange={handleChange}
                                                                    error={Boolean(touchedPricePerUnit && errorPricePerUnit)}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} lg={6}>
                                                                <TextField
                                                                    label="Unit (kg/item)"
                                                                    type="text"
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    name={unit}
                                                                    value={item.unit}
                                                                    helperText={
                                                                        touchedUnit && errorUnit
                                                                        ? errorUnit
                                                                        : ""
                                                                    }
                                                                    onChange={handleChange}
                                                                    error={Boolean(touchedUnit && errorUnit)}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                <TextField
                                                                    label="Quantity Left"
                                                                    type="number"
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    name={quantity}
                                                                    value={item.quantity}
                                                                    helperText={
                                                                        touchedQuantity && errorQuantity
                                                                        ? errorQuantity
                                                                        : ""
                                                                    }
                                                                    onChange={handleChange}
                                                                    error={Boolean(touchedQuantity && errorQuantity)}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                <TextField
                                                                    label="Item Description"
                                                                    type="text"
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    multiline
                                                                    rowsMax={4}
                                                                    name={description}
                                                                    value={item.description}
                                                                    helperText={
                                                                        touchedDescription && errorDescription
                                                                        ? errorDescription
                                                                        : ""
                                                                    }
                                                                    onChange={handleChange}
                                                                    error={Boolean(touchedDescription && errorDescription)}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                <TextField
                                                                    label="Item Ingredients (Optional)"
                                                                    type="text"
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    multiline
                                                                    rowsMax={4}
                                                                    name={ingredients}
                                                                    value={item.ingredients}
                                                                    helperText={
                                                                        touchedIngredients && errorIngredients
                                                                        ? errorIngredients
                                                                        : ""
                                                                    }
                                                                    onChange={handleChange}
                                                                    error={Boolean(touchedIngredients && errorIngredients)}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                {item.fileUrl === null && 
                                                                    <TextField
                                                                        label="Item Image"
                                                                        type="file"
                                                                        fullWidth
                                                                        variant="outlined"
                                                                        name={fileUrl}
                                                                        value={item.fileUrl}
                                                                        onChange={(e) => {
                                                                            const imgObj = e.target.files[0];
                                                                            const parentRef = 'business';
                                                                            const imgNameRef = `${email}_${new Date().getTime()}_${imgObj.name}`;
                                                                            const uploadTask = storage.ref(`${parentRef}/${imgNameRef}`)
                                                                                .put(imgObj);

                                                                            uploadTask.on("state_changed", () => {
                                                                                storage.ref(parentRef)
                                                                                    .child(imgNameRef)
                                                                                    .getDownloadURL()
                                                                                    .then(url => {
                                                                                        item.fileUrl = url
                                                                                    });
                                                                            })
                                                                        }}
                                                                        error={Boolean(touchedFileUrl && errorFileUrl)}
                                                                        InputLabelProps={{ shrink: true }}
                                                                    />
                                                                }
                                                            </Grid>
                                                            <IconButton 
                                                                aria-label="delete"
                                                                onClick={() => arrayHelpers.remove(index)}
                                                                >
                                                                <DeleteIcon />
                                                            </IconButton>
                                                            </Grid>
                                                        </CardContent>
                                                    </Card>
                                                    <br />
                                                </div>
                                            )})
                                            : null}
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            onClick={() =>
                                            arrayHelpers.push(emptyItem)
                                            } 
                                        >
                                            +
                                        </Button>
                                        </div>
                                    )
                                    }}
                                />
                            </Grid>
                        </Grid>
                        <div>
                        </div>
                        <Divider className={classes.divider} />
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => handleSubmit()}
                            isSubmitting={isSubmitting}
                        >
                            Update
                        </Button>
                    </Form>

                )}
            </Formik>
            <Typography variant="h5" className={classes.statusText}>{status}</Typography>
        </>
    )
}

export default Inventories;